
// import React, { useEffect, useState } from "react";
// import Sidebar from "../Sidebar/Sidebar";
// import { Outlet, useLocation, useParams } from "react-router-dom";
// import Footer from "../Footer/Footer";
// import Nav from "../Navbar/Nav";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchWebsiteById } from "../../features/tests/testSlice";




// const Layout = () => {
//   const location = useLocation();
//   const dispatch =useDispatch();
//   const { websiteId } = useParams();


//   const token = localStorage.getItem("Token")
//   useEffect(() => {
//     if (websiteId && token) {
//       dispatch(fetchWebsiteById({ websiteId, token }));
//     }
//   }, [websiteId, token, dispatch]);


//   // const hideSidebarPaths = ["/onboarding", "/addWebsite" ];
//   const hideSidebarPaths = [
//     "/onboarding",
//     "/addWebsite",
//     /^\/share-test\/website\/[^/]+\/footprint\/[^/]+\/video\/[^/]+$/
//   ];

//     const hideNavFooterPaths = ["/onboarding"]

//       const shouldHideNavFooter = hideNavFooterPaths.includes(location.pathname);


//   const shouldHideSidebar = hideSidebarPaths.some(path =>
//     path instanceof RegExp ? path.test(location.pathname) : path === location.pathname
//   );



//   return (
//     <div className="flex flex-col min-h-screen bg-layout">

//       <Nav />

//       {/* <div className=" mx-20 py-2 gap-6 flex  flex-1 overflow-hidden">
//         {!isExtensionInstalled && !shouldHideSidebar && <ExtensionAlert />}
//       </div> */}
//       {/* Content area with sidebar and main content mx-16 */}
//       <div className="outer-section bg-white md:bg-layout   md:mx-20 py-6 gap-6 flex  flex-1 overflow-hidden ">

//         {!shouldHideSidebar && <Sidebar />}

//         <main className="flex-1   overflow-y-auto">
//           {/* {children} */}
//           <Outlet />
//         </main>

//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default Layout;




import React, { useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Outlet, useLocation, useParams } from "react-router-dom";
import Footer from "../Footer/Footer";
import Nav from "../Navbar/Nav";
import { useDispatch } from "react-redux";
import { fetchWebsiteById } from "../../features/tests/testSlice";
import { getUserDetails } from "../../features/user/userSlice";
import {jwtDecode }from "jwt-decode"; // Ensure you have jwt-decode installed
const Layout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { websiteId } = useParams();

  // const token = localStorage.getItem("Token");
  //    const decoded = jwtDecode(token);
  //     const { username, userId } = decoded;

  // useEffect(() => {
  //   if (websiteId && token) {
  //     dispatch(fetchWebsiteById({ websiteId, token }));
  //     // dispatch(getUserDetails({ userId }));


  //   }
  // }, [websiteId, token, dispatch]);

  const hideSidebarPaths = [
    "/onboarding",
    "/addWebsite",
    /^\/share-test\/website\/[^/]+\/footprint\/[^/]+\/video\/[^/]+$/
  ];

  const hideNavFooterPaths = ["/onboarding"]; // Add more paths if needed

  const shouldHideSidebar = hideSidebarPaths.some(path =>
    path instanceof RegExp ? path.test(location.pathname) : path === location.pathname
  );

  const shouldHideNavFooter = hideNavFooterPaths.includes(location.pathname);

  return (
    <div className="flex flex-col min-h-screen bg-layout">
      {!shouldHideNavFooter && <Nav />}

      <div className="outer-section bg-white md:bg-layout md:mx-20 py-6 gap-6 flex flex-1 overflow-hidden">
        {!shouldHideSidebar && <Sidebar />}
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>

      {!shouldHideNavFooter && <Footer />}
    </div>
  );
};

export default Layout;
